export default {
    bind (el, binding, vnode) {
        el.inputMode = 'numeric'
        el.pattern='\d*'

        el.addEventListener('focusin', () => {
            el.select()
        }, false)
        el.addEventListener('blur', () => {
            let params = {}
            try {
                params = JSON.parse(binding.expression)
            } catch (e) {}
            let value_new = el.value.replace(/[０-９]/g, function(s) {
                return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
            })
            value_new = value_new.replace(/[‐－―ー]/g, '-')
                if (params.negative) {
                    value_new = value_new.replace(/[^0-9\-.]/gi, '')
                } else {
                    value_new = value_new.replace(/[^0-9.]/gi, '')
                }
            switch (el.type) {
                case 'tel':
                    break;
                default:
                    if (params.float) {
                        value_new = Number(value_new)
                    } else {
                        value_new = parseInt(value_new)
                    }
                    break;
            }
            if (isNaN(value_new)) {
                value_new = ''
            }
            if (value_new !== el.value) {
                el.value = value_new
                el.dispatchEvent(new Event('input', { bubbles: true, }))
            }
        }, false)
    },
    inserted (el, binding, vnode) {
    },
    update (el, binding, vnode) {
    },
    componentUpdated (el, binding, vnode) {
    },
    unbind (el, binding, vnode) {
    },
}


